import i18n from '@/configs/i18n'
import vi from './vi.json'
import en from './en.json'

// Registers this module's `oncall` namespace (see configs/i18n).
i18n.addResourceBundle('vi', 'oncall', vi)
i18n.addResourceBundle('en', 'oncall', en)
